import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'siselse-interphone',
  template: `
    <ion-item>
      <ion-label position="stacked">Frente de calle:</ion-label>
      <ion-input [(ngModel)]="interphone.no" placeholder="Frente de calle" [disabled]="true"></ion-input>
      
      <ion-label position="stacked">Teléfono:</ion-label>
      <ion-input [(ngModel)]="interphone.tel" placeholder="Tel"></ion-input>    
      
    </ion-item>
    <hr>
  `,
})
export class SiselseInterphoneComponent {
  @Input() interphone: {no:string, tel:string};
}